import { render } from "./BaseButtonIcon.vue?vue&type=template&id=5273bd6c&scoped=true"
import script from "./BaseButtonIcon.vue?vue&type=script&lang=js"
export * from "./BaseButtonIcon.vue?vue&type=script&lang=js"

import "./BaseButtonIcon.vue?vue&type=style&index=0&id=5273bd6c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5273bd6c"]])

export default __exports__